import {useEffect, useState} from 'react';
import {OfficesApiService, useService} from '@innowise-group/core';
import {combineLatest, Subscription} from 'rxjs';
import {EditOfficeFormValues} from './edit-office-form.component';

export function useEditOfficeData(officeId: string) {
  const officesApi = useService(OfficesApiService);

  const [initialValues, setInitialValues] = useState<EditOfficeFormValues | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let subscription: Subscription | undefined;

    setIsLoading(true);
    subscription = combineLatest([officesApi.getOfficeById(officeId), officesApi.getOfficeFloors(officeId)]).subscribe({
      next: ([officeData, floors]) => {
        const values: EditOfficeFormValues = {
          location: officeData.location.id,
          managers:
            officeData.managers?.flatMap(({id, managerType}) =>
              managerType.map((type) => ({office_manager: id, manager_type: type})),
            ) ?? [],
          floors: floors.map((f) => ({number: f.number, isVirtual: f.is_virtual})),
          address: officeData.addressRu,
          address_eng: officeData.addressEng,
          index: officeData.postcode,
          jira_office_id: officeData.jiraOfficeId,
        };

        setInitialValues(values);
        setIsLoading(false);
      },
      error: (err) => {
        console.error(err);
        setError(err);
        setIsLoading(false);
      },
    });

    return () => subscription?.unsubscribe();
  }, [officeId, officesApi]);

  return {initialValues, isLoading, error};
}
